$('.filtr-button').click(function() {
    $('.filtr-button').removeClass('active');
    $(this).addClass('active');

    setTimeout(
        function()
        {
            if($('#products').height() == 0) {
                $('.information-message').show();
            }
            else {
                $('.information-message').hide();
            }

        }, 300);
});


$('#all').click(function() {
    $('.filtr-button').removeClass('active');
});


$('.addressClick1').click(function() {
    $('#menu1').show();
    $('#menu2').hide();
    $('#menu3').hide();
});

$('.addressClick2').click(function() {
    $('#menu1').hide();
    $('#menu2').show();
    $('#menu3').hide();
});

$('.addressClick3').click(function() {
    $('#menu1').hide();
    $('#menu2').hide();
    $('#menu3').show();
});

